export default defineNuxtPlugin(() => {
  // Only provide the auth composable, no initialization
  return {
    provide: {
      auth: useAuth()
    }
  }
})
